/**
 * API Configuration - Always uses same origin for API calls
 * This ensures the app works on any domain (preview or custom)
 */

const getApiUrl = () => {
  // Always use same origin - works for both preview and custom domains
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  
  // Fallback for SSR/build time
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const API_BASE_URL = getApiUrl();
export const API = `${API_BASE_URL}/api`;
